import { toastSuccess } from "@features/shared/presentation";
import { trans } from "@taager/localization";
import clsx, { type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind classes with clsx
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Copy text to clipboard
 */
export function copyToClipboard(text: any, successMessage: string) {
  navigator.clipboard.writeText(text);

  toastSuccess(trans(successMessage));
}
